import axios from 'axios';

export default {
  namespaced: true,
  actions: {
    roleList({ commit }, params) {
      return axios.get('/access/ajax/roleList', {
        params: {
          name: params.name,
          enable: params.enable,
          page: params.page,
          size: params.size
        }// ,
        // cache: true,
      }).then((data) => {
        return data;
      });
    },
    roleSave({ commit }, params = {}) {
      return axios.post('/access/ajax/roleSave', params, { global: false }).then((data) => {
        return data;
      });
    },
    roleUpdate({ commit }, params = {}) {
      return axios.post('/access/ajax/roleUpdate', params, { global: false }).then((data) => {
        return data;
      });
    },
    roleDetail({ commit }, params = {}) {
      return axios.get('/access/ajax/roleDetail', params, { global: false }).then((data) => {
        return data;
      });
    },
    start({ commit }, params = {}) {
      return axios.post('/access/ajax/roleStart', params, { global: false }).then((data) => {
        return data;
      });
    },
    stop({ commit }, params = {}) {
      return axios.post('/access/ajax/roleStop', params, { global: false }).then((data) => {
        return data;
      });
    },
    roleLog({ commit }, params = {}) {
      return axios.get('/access/ajax/roleLog', params, { global: false }).then((data) => {
        return data;
      });
    },
    getRoleById({ commit }, params = {}) {
      return axios.get('/access/ajax/getRoleById', params, { global: false }).then((data) => {
        return data;
      });
    },
    getMenusListById({ commit }, params) {
      return axios.get('/access/ajax/getMenusListById', params, { global: false }).then((data) => {
        return data;
      });
    }
  },
};
